import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Transactions from "./Transactions";
import {
  fetchTransactions,
  resetWallet
} from "../../../../../store/wallet/actions";

class TransactionsContainer extends Component {
  render() {
    return <Transactions {...this.props} />;
  }
}

const mapStateProps = state => ({
  user: state.user.info,
  transactions: state.walletState.transactions,
  total: state.walletState.total,
  tournament: state.tournamentState.tournament
});

const mapDispatchToProps = {
  fetchTransactions,
  resetWallet
};

export default connect(
  mapStateProps,
  mapDispatchToProps
)(withRouter(TransactionsContainer));
